import { TDurationFilterType } from 'libs/ui/src/lib/filter/model/ui-filter.types';
import moment from 'moment';

export const CUTBANK_DATE_FILTER_UTIL = {
  isValid(dateFilter: TDurationFilterType, startLimit: number, range: number) {
    if (dateFilter.type !== 'CUSTOM') return { isValid: true };

    const startAndEndTime = this.getStartAndEndTime(dateFilter);
    if (startAndEndTime.start > startAndEndTime.end) {
      return {
        isValid: false,
        errorType: 'START_IS_GREATER' as const,
      };
    } else if (
      startLimit &&
      new Date().setHours(0, 0, 0, 0) - new Date(startAndEndTime.start).setHours(0, 0, 0, 0) > startLimit * 86400000
    ) {
      return {
        isValid: false,
        errorType: 'START_OUT_OF_RANGE' as const,
      };
    } else if (
      range &&
      new Date(startAndEndTime.end).setHours(0, 0, 0, 0) - new Date(startAndEndTime.start).setHours(0, 0, 0, 0) >
        range * 86400000
    ) {
      return {
        isValid: false,
        errorType: 'RANGE_OUT_OF_RANGE' as const,
      };
    } else return { isValid: true };
  },

  getSelectedDateString(dateFilter: TDurationFilterType): string {
    const startAndEndTime = this.getStartAndEndTime(dateFilter);
    switch (dateFilter.type) {
      case 'TODAY':
        return moment(startAndEndTime.start).format('ll');
      case 'MONTHLY':
      case 'WEEKLY':
      case 'CUSTOM':
        return moment(startAndEndTime.start).format('ll') + ' - ' + moment(startAndEndTime.end).format('ll');
      case 'YESTERDAY':
        return moment(startAndEndTime.start).format('ll');
    }
  },

  getStartAndEndTime(dateFilter: TDurationFilterType) {
    switch (dateFilter.type) {
      case 'TODAY': {
        const startDay = moment().local(true).startOf('day').valueOf();
        const endDay = moment().local(true).endOf('day').valueOf();
        return {
          start: startDay,
          end: endDay,
          type: dateFilter.type,
        };
      }
      case 'YESTERDAY': {
        const startDay = moment().local(true).subtract(1, 'day').startOf('day').valueOf();
        const endDay = moment().local(true).subtract(1, 'day').endOf('day').valueOf();
        return {
          start: startDay,
          end: endDay,
          type: dateFilter.type,
        };
      }
      case 'WEEKLY': {
        const startDay = moment().local(true).subtract(7, 'day').startOf('day').valueOf();
        const endDay = moment().local(true).endOf('day').valueOf();
        return {
          start: startDay,
          end: endDay,
          type: dateFilter.type,
        };
      }
      case 'MONTHLY': {
        const startDay = moment().local(true).startOf('day').subtract(1, 'month').valueOf();
        const endDay = moment().local(true).endOf('day').valueOf();
        return {
          start: startDay,
          end: endDay,
          type: dateFilter.type,
        };
      }
      case 'CUSTOM': {
        return {
          start: dateFilter.start
            ? moment(dateFilter.start).startOf('day').valueOf()
            : moment().startOf('day').valueOf(),
          end: dateFilter.end ? moment(dateFilter.end).endOf('day').valueOf() : moment().endOf('day').valueOf(),
          type: dateFilter.type,
        };
      }
    }
  },
};
